import React, { Component } from 'react';
import card from 'card-validator';
import Validator from 'validatorjs';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';

import './support/GuardDuty';
import { Event } from './support';
import { resetStore } from './store';
import Bridge from './shared/Bridge';
import AppLayout from './layouts/AppLayout';
import AuthLayout from './layouts/AuthLayout';
import AdminLayout from './layouts/AdminLayout';
import GuardedRoute from './shared/GuardedRoute';
import AccountLayout from './layouts/AccountLayout';
import ExternalLayout from './layouts/ExternalLayout';
import ToastManager from './shared/toast/ToastManager';
import PageError404 from './shared/errors/PageError404';
import ReceptoresBridge from './shared/ReceptoresBridge';
import DevelopersLayout from './layouts/DevelopersLayout';
import AccountSuspended from './app/auth/AccountSuspended';
import AdditionalModulesLayout from './layouts/AdditionalModulesLayout';
import SendMailToFacturacion from './layouts/components/SendMailToFacturacion';

window.noop = () => {};

window.downloadFromHttpResponse = (response) => {
  const filenameHeader = response.headers['content-disposition'].split(';')[1];
  const filename = filenameHeader.substring(filenameHeader.indexOf('=') + 1);
  const url = URL.createObjectURL(response.data);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);

  document.body.append(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

window.BONJOUR_URL = process.env.REACT_APP_BONJOUR_SERVER || process.env.REACT_APP_API_SERVER;

window.resetApp = async () => {
  resetStore();

  Event.dispatch('app.refresh');
};

window.setAppTitle = () => {};

Validator.useLang('es');

Validator.register(
  'password',
  function (value, requirement, attribute) {
    return value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W|_]).{8,}.+$/u);
  },
  'El password debe contener una números, letras, al menos una mayúscula y un caracter especial.'
);

Validator.register(
  'card_number',
  function (value, requirement, attribute) {
    return card.number(value !== undefined ? value.replace(' ', '') : '')?.isValid;
  },
  'Número de tarjeta inválido.'
);

Validator.register(
  'card_expiration',
  function (value, requirement, attribute) {
    return card.expirationDate(value)?.isValid;
  },
  'La fecha de expiración es inválida.'
);

Validator.register(
  'card_cvc',
  function (value, requirement, attribute) {
    return card.cvv(value)?.isValid;
  },
  'El código verificador es inválido.'
);

Validator.register('nullable', () => true);

const decimalFn = function (value, requirement = 2, attribute) {
  const regexp = new RegExp(`^\\d+(\\.\\d{1,${requirement}})?$`, 'iu');

  return regexp.test(value);
};

Validator.register('decimal', decimalFn, 'Inválido');

const uuidFn = function (value, requirement = 2, attribute) {
  const regexp = new RegExp(`^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$`, 'iu');

  return regexp.test(value);
};

Validator.register('uuid', uuidFn, 'El uuid ingresado es inválido');

const integerFn = function (value, requirement, attribute) {
  return String(parseInt(value, 10)) === String(value);
};

Validator.register('int', integerFn, 'Inválido');

let messages = Validator.getMessages('es');

messages.string = 'El campo :attribute debe ser una cadena.';

messages.required_without = 'El campo :attribute es obligatorio cuando :field está vacío.';

// messages.decimal = 'Invalid decimal value.';
Validator.setMessages('es', messages);

const userAgent = navigator.userAgent.toLowerCase();
const isElectronBrowser = userAgent.indexOf(' electron/') > -1;
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <ToastManager />
        <Switch>
          <Route
            path="/errors/"
            component={PageError404}
          />

          <Route
            path="/ext/"
            component={ExternalLayout}
          />

          <Route
            path="/auth"
            component={AuthLayout}
          />
          <Route
            path="/bridge"
            component={Bridge}
            exact
          />
          <Route
            path="/suspended"
            component={AccountSuspended}
            exact
          />
          <Route
            path="/suspended/send-mail"
            component={SendMailToFacturacion}
            exact
          />
          <Route
            path="/bridge/receptores"
            component={ReceptoresBridge}
            exact
          />

          <GuardedRoute
            path="/app"
            component={AppLayout}
            redirectTo="/bridge"
          />
          <GuardedRoute
            path="/admin"
            component={AdminLayout}
            redirectTo="/bridge"
          />
          <GuardedRoute
            path="/developers"
            component={DevelopersLayout}
            redirectTo="/bridge"
          />
          <GuardedRoute
            path="/cuenta"
            component={AccountLayout}
            redirectTo="/bridge"
          />
          <GuardedRoute
            path="/modulos"
            component={AdditionalModulesLayout}
            redirectTo="/bridge"
          />
          {!isElectronBrowser && (
            <Route
              path="/*"
              component={() => <Redirect to="/errors/404" />}
            />
          )}
          {isElectronBrowser && (
            <Route
              path="/*"
              component={() => <Redirect to="/bridge" />}
            />
          )}
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
